import { ChevronDownIcon, Flex, Text } from '@radix-ui/themes'
import { Accordion as RadixAccordion } from 'radix-ui'
import { JSX } from 'react'
import './accordion.scss'

export type AccordionItems = {
  id: string
  value: string
  name?: string
  actionButton?: JSX.Element
  child: JSX.Element
}
export type AccordionProps = {
  items: AccordionItems[]
  values?: string[]
  onValueChange?: (values: string[]) => void
}

export const Accordion = ({ items, onValueChange, values }: AccordionProps) => {
  const accordianItems = items.map((item) => {
    return (
      <RadixAccordion.Item key={item.id} value={item.value}>
        {item.name ? (
          <RadixAccordion.Header className="AccordionHeader">
            <RadixAccordion.Trigger className="AccordionTrigger">
              <Text>{item.name}</Text>
              <Flex gap="6">
                {item.actionButton ?? null}
                <Flex>
                  <ChevronDownIcon className="AccordionChevron" aria-hidden />
                </Flex>
              </Flex>
            </RadixAccordion.Trigger>
          </RadixAccordion.Header>
        ) : null}
        {item.child}
      </RadixAccordion.Item>
    )
  })

  return (
    <RadixAccordion.Root type="multiple" value={values} onValueChange={onValueChange}>
      {accordianItems}
    </RadixAccordion.Root>
  )
}
